export function useApi() {
  const BASE_URL = import.meta.env.VITE_API_URL

  if (!BASE_URL) {
    throw new Error('VITE_API_URL is not defined in environment variables')
  }

  const getApiUrl = (path: string) => `${BASE_URL}/${path}`

  return {
    getApiUrl,
  }
}
